<template>
  <modal :modal-key="'no-balance-modal'"
         :class-style="'modal--welcomeback modal--zero-balance'"
         @close="$emit('close')">
    <template slot="header">
      <h1>{{ getTranslations.home_modals_no_balance_your_balance }}</h1>
      <img class="usericon" src="static/images/oops.svg" alt="">
    </template>
    <template slot="modal__body">
      {{ getTranslations.home_modals_no_balance_your_need_to_unlock }}
    </template>
    <template slot="modal__footer"></template>
  </modal>
</template>

<script>
import { mapGetters } from 'vuex';
import Modal from '@/components/home/modals/shared/GenericModal';

export default {
  name: 'no-balance',
  components: {
    Modal,
  },
  created() {
    this.showModal();
  },
  methods: {
    showModal() {
      /* eslint-disable */
      const vm = this;
      this.$nextTick(() => {
        // open modal
        $('.modal,.modal-overlay').fadeIn(200);
        // show/hide modal
        $('.modal-close, .modal-overlay').click(function () {
          vm.$emit('close');
          $('#welcome_modal').fadeOut();
        });
      });
      /* eslint-enable */
    },
  },
  computed: {
    ...mapGetters('i18n', [
      'getTranslations',
    ]),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/home/modals/NoBalanceModal.vue